const EXCHANGE_STATUS = {
  unassigned: 1, // Не назначен, на бирже не отображается (черновик)
  market: 2, // На бирже, доступен для заявок от организаций
  pending: 3, // Организация выбрана владельцем, ожидается создание мероприятия
  assigned: 4, // Назначен, мероприятие создано
  rejected: 5, // Отклонён владельцем
};

export default {
  EXCHANGE_STATUS,
};
